import React from 'react';

export interface DetailCardProps {
    title?: React.ReactNode;
    children: React.ReactNode;
}

export interface DetailCardRowProps {
    label: React.ReactNode;
    value: React.ReactNode;
}

const DetailCardRoot = (props: DetailCardProps) => {
    return (
        <div className='flex w-full flex-col items-start gap-3'>
            {props.title && <div className='justify-center'>{props.title}</div>}
            <div className='bg-background-surface border-border-default flex w-full flex-col items-start gap-2 rounded-xl border p-4'>{props.children}</div>
        </div>
    );
};

const DetailCardRow = (props: DetailCardRowProps) => {
    return (
        <div className='flex min-h-6 w-full items-start justify-between gap-4'>
            <p className='text-brand-muted shrink-0'>{props.label}</p>
            <span className='min-w-0 text-right wrap-break-word'>{props.value}</span>
        </div>
    );
};

const DetailCardSeparator = () => {
    return <div className='border-border-default w-full border-b' />;
};

export const DetailCard = Object.assign(DetailCardRoot, {
    Row: DetailCardRow,
    Separator: DetailCardSeparator
});
